// extracted by mini-css-extract-plugin
export default {"root":"_3tPX7","left":"_1tiQ6","right":"_3g6NE"};